import { CollaborationStatus } from '@99designs/graph-utils/types';
import { __ } from '@99designs/i18n';
import { DRAFT_BRIEF_STATUS, PENDING_FULFILMENT_STATUS } from '../utils/constants';

export function getDisplayStatus(status: CollaborationStatus | string | undefined): string {
    if (!status) return '';

    switch (status) {
        case 'COLLABORATION_STATUS_REQUEST_SUBMITTED':
            return __('Request Submitted');

        case 'COLLABORATION_STATUS_DESIGN_IN_PROGRESS':
            return __('Design in Progress');

        case 'COLLABORATION_STATUS_REVISION_IN_PROGRESS':
            return __('Edits Received');

        case 'COLLABORATION_STATUS_READY_FOR_REVIEW':
            return __('Ready for Review');

        case 'COLLABORATION_STATUS_CANCELLED':
            return __('Canceled');

        case 'COLLABORATION_STATUS_APPOINTMENT_SCHEDULED':
            return __('Appointment Scheduled');

        case 'COLLABORATION_STATUS_APPOINTMENT_IN_SESSION':
            return __('Appointment in Session');

        case 'COLLABORATION_STATUS_APPOINTMENT_PREPARING':
            return __('preparing-for-appointment');

        case 'COLLABORATION_STATUS_CLOSED':
            return __('Closed');

        case 'COLLABORATION_STATUS_REVISIONS_COMPLETE':
            return __('Project completed');

        case 'COLLABORATION_STATUS_DESIGN_APPROVED':
            return __('Design Approved');

        case DRAFT_BRIEF_STATUS:
            return __('Draft');

        case PENDING_FULFILMENT_STATUS:
            return __('Order Processing');

        default:
            return '';
    }
}
